import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Badge, Button, Col, Container, FloatingLabel, Form, Image, InputGroup, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { LoginInfo } from '../App';
import { isLoggin } from '../service/LoginService';
import ApiFetch from './ApiFetch';
import Category from './Category';
import Dialog from './Dialog';
import Footer from './Footer';
import Header from './Header';

async function getFavoriteList(page){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/list/"+page).then((r)=>r.json().then((json)=>{
        return json
    }))
}
const Painter = (props) => {
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲート
    const navigate = useNavigate();
    // URLパラメータ
    let param = useParams();

    const [layers,setLayers] = useState([...Array(0)])
    const [message,setMessage] = useState('')

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // 初期処理
    useEffect(() =>{
        // タイトル設定
        document.querySelector("title").textContent = "ペイント(beta) - アワート"
    },[])

    var canvasArea
    var canvasRgba = "rgba(0,0,0,1)"
    var layerC
    var layerCtx
    var pointerC
    var pointerCtx
    var startX
    var startY
    var mode = 1
    var brushSize = 5 // ブラシサイズ
    var isMouseDown = false
    /**
     * 1:ポインター
     * 2:描画
     */

    window.addEventListener("load",function(){
        canvasArea = document.querySelector("#canvasArea")
    })
    function mouseUp(){
        isMouseDown = false
    }
    function mouseDown(e){
        isMouseDown = true
        startX = e.offsetX;
        startY = e.offsetY;
    }
    function mouseMove(e){
        if(mode === 1){
            pointer(e)
            if(isMouseDown){
                drawPen(e)
            }
            
        } else if(mode === 2){
            pointer(e)
            if(isMouseDown){
                drawErase(e)
            }
        }
        
    }
    function pointer(e){
        // 事前のポインタ描画を除去
        pointerCtx.clearRect(0, 0, pointerC.width, pointerC.height)

        if (mode === 2) {
            // モード：消しゴムのときは白固定
            pointerCtx.strokeStyle = "rgba(255, 255, 255, 1)";
        } else {
            pointerCtx.strokeStyle = canvasRgba; // 事前に設定していた色
        }

        pointerCtx.lineWidth = brushSize; // 太さ
        pointerCtx.lineCap = "round"; // 円

        pointerCtx.beginPath();
        pointerCtx.moveTo(e.offsetX, e.offsetY);
        pointerCtx.lineTo(e.offsetX, e.offsetY); // 開始座標と終了座標を同じ
        pointerCtx.stroke(); // 描画
        pointerCtx.closePath();
    }
    function drawPen(e){
        layerCtx.lineWidth = brushSize;
        layerCtx.strokeStyle = canvasRgba;
        layerCtx.lineJoin = "round";
        layerCtx.lineCap = "round";
        layerCtx.globalCompositeOperation = 'source-over';
        layerCtx.beginPath();
        layerCtx.moveTo(startX, startY); // 開始座標（前回座標）
        layerCtx.lineTo(e.offsetX, e.offsetY); // 終了座標（現在座標）
        layerCtx.stroke(); // 直線を描画
        layerCtx.closePath();

        startX = e.offsetX
        startY = e.offsetY
    }
    function drawErase(e){
        layerCtx.lineWidth = brushSize;
        layerCtx.lineCap = "round"; // 先端の形状
        layerCtx.strokeStyle = "rgba(255, 255, 255, 1)"; // 色はなんでもよいが、透過度は1にする
        layerCtx.globalCompositeOperation = 'destination-out' // 塗りつぶした個所を透明化
        layerCtx.beginPath();
        layerCtx.moveTo(startX, startY); // 開始座標（前回座標）
        layerCtx.lineTo(e.offsetX, e.offsetY); // 終了座標（現在座標）
        layerCtx.stroke(); // 描画
        layerCtx.closePath();
    
        // 次の描画に向けて現在の座標を保持（開始座標・終了座標を同じ座標にしてしまうと、マウスを高速に移動したときに歯抜け状態になる）
        startX = e.offsetX;
        startY = e.offsetY;
    }
    function createCanvas(width,height){
        let canvas = document.createElement("canvas")
        canvas.style.top = 0
        canvas.style.left = 0
        canvas.style.right = 0
        canvas.style.bottom = 0
        canvas.style.margin = "auto"
        canvas.style.position = "absolute"
        canvas.style.border = "1px solid #000000"
        canvas.width = width
        canvas.height = height
        console.log(canvas,width)
        return canvas
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Container><Category /></Container>
        <Container>
            <Form style={{width:"200px"}}>
                <Row>
                    <Col>
                        <FloatingLabel controlId="canvas-width" label="横幅">
                            <Form.Control type="number" cows="10" defaultValue="500" />
                        </FloatingLabel>
                    </Col>
                    <Col>
                        <FloatingLabel controlId="canvas-height" label="縦幅">
                            <Form.Control type="number" cows="10" defaultValue="500" />
                        </FloatingLabel>
                    </Col>
                </Row>
                <Button onClick={() => {
                    let canvasWidth = document.querySelector("#canvas-width").value
                    let canvasHeight = document.querySelector("#canvas-height").value
                    document.querySelector("#canvasArea").width = canvasWidth
                    document.querySelector("#canvasArea").height = canvasHeight

                    let layer = createCanvas(canvasWidth,canvasHeight)
                    layer.dataset.no = 1
                    canvasArea.appendChild(layer)

                    let drawTargetTemp = createCanvas(canvasWidth,canvasHeight)
                    drawTargetTemp.id = "drawTargetTemp"
                    let drawTargetPointer = createCanvas(canvasWidth,canvasHeight)
                    drawTargetPointer.id = "drawTargetPointer"
                    pointerC = drawTargetPointer

                    canvasArea.appendChild(drawTargetTemp)
                    canvasArea.appendChild(drawTargetPointer)

                    // コンテキスト取得
                    layerCtx = layer.getContext("2d")
                    pointerCtx = drawTargetPointer.getContext("2d")
                    console.log(layerCtx)
                }}>確定</Button>
                <Row>
                    <Col>
                        <Button onClick={() => mode = 1}>描画</Button>
                    </Col>
                    <Col>
                        <Button onClick={() => mode = 2}>消しゴム</Button>
                    </Col>
                </Row>
                <Row>
                    <Col><input type="color" onChange={(e) => canvasRgba = e.target.value} /></Col>
                </Row>
            </Form>
            描画、一時用、ポインター
            <div id="canvasArea" style={{width:"100%",height:"80vh",position:"relative",border:"1px solid #FF0000",overflow:"hidden"}}
                onMouseUp={(e) => mouseUp(e.nativeEvent)}
                onMouseMove={(e) => mouseMove(e.nativeEvent)}
                onMouseDown={(e) => mouseDown(e.nativeEvent)}
                >

            </div>
        </Container>
        
    </div>
    )
}

export default Painter;
